import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import GroupsPage from "../components/GroupsPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const GroupsPageContainer = connect(mapStateToProps, mapDispatchToProps)(GroupsPage);

export default GroupsPageContainer;


// WEBPACK FOOTER //
// ./src/containers/GroupsPageContainer.js